(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('QuestionOption', QuestionOption);

    QuestionOption.$inject = ['$resource'];

    function QuestionOption ($resource) {
        var resourceUrl =  'api/question-options/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
